import { useNavigate } from "react-router-dom";
import "../../assets/css/packageCard.css";

function PackageCard({
    id,
    title,
    image,
    price,
    features
}) {

    const navigate = useNavigate();

    return (

        <div className="customer-package-card">

            <div className="customer-package-card-image">

                <img
                    src={image}
                    alt={title}
                />

                <div className="customer-package-card-price">
                    {price}
                </div>

            </div>

            <div className="customer-package-card-content">

                <h2 className="customer-package-card-title">
                    {title}
                </h2>

                <ul className="customer-package-card-features">

                    {features?.map((feature, index) => (

                        <li key={index}>
                            {feature}
                        </li>

                    ))}

                </ul>

                <button
                    className="customer-package-card-btn"
                    onClick={() =>
                        navigate(`/package/${id}`, {
                            state: {
                                title,
                                image,
                                price,
                                features
                            }
                        })
                    }
                >
                    View Package →
                </button>

            </div>

        </div>

    );

}

export default PackageCard;